import participantsApi from '../participants/participantsApi';

export const verifyMyLoginUser = async (myLoginUserData) => {
  try {
    if (!myLoginUserData || !myLoginUserData.user) {
      throw new Error('Invalid user data received from MyLogin');
    }

    const { id, email, first_name, last_name, organisation } = myLoginUserData.user;


    if (!id) {
      throw new Error(
        'Your account does not have Wonde/MyLogin login support. Please contact your school administrator.'
      );
    }

    // Create request payload according to SocialAuthRequest model
    const payload = {
      email: email,
      idToken: id, // Use the Wonde ID as the idToken
      provider: 'mylogin',
      firstName: first_name,
      lastName: last_name,
    };

    // Add organisation data if available
    if (organisation) {
      payload.organisationId = organisation.id;
      payload.organisationName = organisation.name;
    }

    // Call API with the structured payload
    const response = await participantsApi.verifyStudent(payload);

    if (!response) {
      throw new Error('No response received from student verification');
    }

    let student;
    if (typeof response === 'string') {
      try {
        student = JSON.parse(response);
      } catch (parseError) {
        throw new Error('Error processing response from server');
      }
    } else {
      student = response;
    }

    if (student && student.success === false) {
      throw new Error(student.message || 'Student verification failed');
    }

    if (student && student.studentId > 0) {
      localStorage.setItem('pupil', typeof response === 'string' ? response : JSON.stringify(response));
      return {
        success: true,
        user: student,
        isAuthenticated: true,
      };
    } else {
      throw new Error('Invalid student data received');
    }
  } catch (error) {
    // Provide a more user-friendly error message based on the response
    if (error.response) {
      switch (error.response.status) {
        case 401:
          throw new Error('Your MyLogin account is not authorized to access this application');
        case 404:
          throw new Error('Your MyLogin account is not associated with any student record');
        case 403:
          throw new Error('Access denied. Please contact your school administrator');
        default:
          throw new Error(error.response.data?.message || 'Failed to verify user with the system');
      }
    }
    throw error;
  }
};

export const completeMyLoginAuthentication = async (myLoginUserData) => {
  return await verifyMyLoginUser(myLoginUserData);
};

export default {
  verifyMyLoginUser,
  completeMyLoginAuthentication,
};
